import React from 'react';
import './Footer.css';

function Footer() {
    return (
        <footer className="footer" style={{
            backgroundImage: 'url("/footer.png")',
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat'
        }}>
            <div className="footer-content">
                <div className="footer-section">
                    <div className="text-start">
                        <img src="/textLogo.png" alt="Cresco Ventures" className='img-fluid mb-2' 
                            style={{ maxWidth: '250px', width: '100%', height: 'auto' }} />
                        <p className='text-white mb-0'>Cresco Ventures</p>
                    </div>
                </div>
                <div className="footer-section">
                    <ul className='text-start ps-0'>
                        <li><a href="/" style={{ color: 'white' }}>Home</a></li>
                        <li><a href="/services" style={{ color: 'white' }}>Services</a></li>
                        <li><a href="/cybersecurity" style={{ color: 'white' }}>Cybersecurity</a></li>
                    </ul>
                </div>
                <div className="footer-section">
                    <ul className='text-start ps-0'>
                        <li><a href="/partners" style={{ color: 'white' }}>Partners</a></li>
                        <li><a href="/about" style={{ color: 'white' }}>About Us</a></li>
                        <li><a href="/contactus" style={{ color: 'white' }}>Contact Us</a></li>
                    </ul>
                </div>
            </div>
            <div className="footer-bottom w-100 d-flex align-items-center justify-content-between">
                <div className="col-auto px-2 ms-5">
                    <p className="mb-0" style={{ color: 'white', fontSize: '12px' }}>CRESCO. All rights reserved.</p>
                </div>
                <div className="col-auto px-2 me-5">
                    <div className="social-links">
                        <a href="https://facebook.com" style={{ color: 'white' }} target="_blank" rel="noopener noreferrer">
                            <i className="bi bi-facebook"></i>
                        </a>
                        <a href="https://www.linkedin.com/company/cresco-ventures-sdn-bhd/" style={{ color: 'white' }} target="_blank" rel="noopener noreferrer">
                            <i className="bi bi-linkedin"></i>
                        </a>
                    </div>
                </div>
            </div>
        </footer>
    );
}

export default Footer; 